/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_SponsorInputs */



/**
* | output |
* | --- |
* | "Sponsor" |
*
* @param {Vekn_SponsorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_sponsor = /** @type {((inputs?: Vekn_SponsorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_SponsorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parrainer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Patrocinar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Patrocinar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sponsor")
	return /** @type {LocalizedString} */ ("Sponsor")
});